import React from 'react'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'
import GlobalCSS from 'src/components/GlobalCSS'
import SEO from 'src/components/seo'
import MaxWidthWrapper from 'src/components/atoms/wrappers/MaxWidthWrapper'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import SubPageTopLayout from 'src/components/organisms/SubPageTopLayout'
import PaperCard from 'src/components/molecules/PaperCard'
import Header from 'src/components/organisms/Header'
import Footer from 'src/components/organisms/Footer'
import { BreakPoint } from 'src/components/shared/CssValues'
import HeadTitle from 'src/components/atoms/HeadTitle'

const whitePapers = [
  {
    thumbnailName: 'commmuneIntroduction',
    subtitle: '３分で分かるcommmune',
    linkTo: '/whitepapers/commmune_introduction'
  },
  {
    thumbnailName: 'commmuneCommunityMarketing',
    subtitle: 'コミュニティマーケティング超入門',
    linkTo: '/whitepapers/commmune_communitymarketing_WP'
  },
  {
    thumbnailName: 'commmuneCommunityTouch',
    subtitle: 'コミュニティタッチ概論',
    linkTo: '/whitepapers/commmune_community_touch'
  },
  {
    thumbnailName: 'commmuneCommonMistakes',
    subtitle: 'コミュニティ運営のよくある失敗と気をつけるべきポイント',
    linkTo: '/whitepapers/commmune_commonmistakes_WP'
  },
  {
    thumbnailName: 'commmuneAirbnbAdopted',
    subtitle: 'Airbnbも取り入れているコミュニティマーケティングとは？',
    linkTo: '/whitepapers/commmune_airbnb_adopted_WP'
  },
  {
    thumbnailName: 'commmuneFanmarketing',
    subtitle: 'ロイヤルユーザーを増やすには...\n知っておきたいファンマーケティングとは？',
    linkTo: '/whitepapers/commmune_fanmarketing_WP'
  },
  {
    thumbnailName: 'commmuneCommunitymarketing3merits',
    subtitle: 'ファンをつくるなら取り組みたい\n「コミュニティマーケティング」がもたらす３つのメリット',
    linkTo: '/whitepapers/commmune_communitymarketing_3merits_WP'
  },
  {
    thumbnailName: 'commmuneSnsAndCommunitysite',
    subtitle: '熱量の高いファンを育てる\n-SNSとコミュニティサイトの効果的な使い分け-',
    linkTo: '/whitepapers/commmune_sns_and_communitysite_WP'
  },
  {
    thumbnailName: 'communitymarketingReport_01_2022',
    subtitle: 'コミュニティマーケティングレポート\nコミュニティ関連施策従事者向けアンケート\n【お取り組み施策編】',
    linkTo: '/whitepapers/commmune_communitymarketing_report_01_2022_WP'
  },
]

const caseStudies = [
  {
    subtitle: 'commmune活用事例集',
    thumbnailName: 'CollectionThumbnail',
    linkTo: '/whitepapers/case_studies/collection/01/'
  },
  {
    subtitle: 'ベースフード株式会社',
    thumbnailName: 'BasefoodThumbnail',
    linkTo: '/whitepapers/case_studies/basefood/01/'
  },
  {
    subtitle: 'ベースフード株式会社 vol.2',
    thumbnailName: 'Basefood2Thumbnail',
    linkTo: '/whitepapers/case_studies/basefood/02/'
  },
  {
    subtitle: '株式会社バウコミュニケーションズ',
    thumbnailName: 'BauThumbnail',
    linkTo: '/whitepapers/case_studies/baucommunications/01/'
  },
  {
    subtitle: 'ウイングアーク１ｓｔ株式会社',
    thumbnailName: 'WingArcThumbnail',
    linkTo: '/whitepapers/case_studies/wingarc1st/01/'
  },
  {
    subtitle: '株式会社オービックビジネスコンサルタント（OBC）',
    thumbnailName: 'OBCThumbnail',
    linkTo: '/whitepapers/case_studies/obc/01/'
  },
  {
    subtitle: 'ユーザックシステム株式会社',
    thumbnailName: 'UsacThumbnail',
    linkTo: '/whitepapers/case_studies/usac/01/'
  },
  {
    subtitle: 'MIKAWAYA21株式会社',
    thumbnailName: 'Mikawaya21Thumbnail',
    linkTo: '/whitepapers/case_studies/mikawaya21/01/'
  },
  {
    subtitle: 'ライフ＆ワークデザイン株式会社',
    thumbnailName: 'LifeworkdesignThumbnail',
    linkTo: '/whitepapers/case_studies/life&workdesign/01/'
  }
]

class WhitePaper extends React.Component {
  render() {
    const { data } = this.props
    return (
      <>
        <SEO
          title="資料ダウンロード"
          description="commmuneは、企業とユーザーが融け合うコミュニティサクセスプラットフォームです。オンライン顧客接点・ユーザーコミュニティの構築を通じ、LTVの向上、マーケティング効果の創出を実現します。"
        />
        <Container>
          <GlobalCSS />
          <Header />
          <SubPageTopLayout title="資料ダウンロード" heading="DOWNLOAD" />
          <MaxWidthWrapper>
            <ContentsWrapper>
              <Section>
                <Title as="h2">ホワイトペーパー</Title>
                <PaperCardList length={whitePapers.length}>
                  {whitePapers.map((paper, i) => {
                    const { childImageSharp } = data[paper.thumbnailName]
                    const imageFluid = childImageSharp && childImageSharp.fluid
                    return (
                      <PaperCard {...paper} imageFluid={imageFluid} key={i} />
                    )
                  })}
                </PaperCardList>
              </Section>
              <Section>
                <Title as="h2">導入事例</Title>
                <PaperCardList length={caseStudies.length}>
                  {caseStudies.map((study, i) => {
                    const { childImageSharp } = data[study.thumbnailName]
                    const imageFluid = childImageSharp && childImageSharp.fluid
                    return (
                      <PaperCard {...study} imageFluid={imageFluid} key={i} />
                    )
                  })}
                </PaperCardList>
              </Section>
            </ContentsWrapper>
          </MaxWidthWrapper>
          <Footer />
        </Container>
      </>
    )
  }
}

const Container = styled.div`
  z-index: 0;
  position: relative;
  overflow: hidden;
`

const Section = styled.section`
  margin: 60px 0;
`

const PaperCardList = styled.div`
  /*PC向け*/
  display: grid;
  grid-template-columns: ${({ length }) =>
    length > 3 ? 'repeat(3, 1fr)' : `repeat(${length}, 1fr)`};
  gap: 40px;
  /*タブレット向け*/
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }
  /*スマホ向け*/
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`

const Title = styled(HeadTitle)`
  text-align: center;
`

export default WhitePaper

export const query = graphql`
  query {
    commmuneOnlineCustomer: file(
      relativePath: { eq: "whitepapers/commmune-online-customer.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneCommunityMarketing: file(
      relativePath: { eq: "whitepapers/commmune-community-marketing.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneIntroduction: file(
      relativePath: { eq: "whitepapers/commmune-introduction.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneCommunityTouch: file(
      relativePath: { eq: "whitepapers/commmune-community-touch.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneCustomerSuccess2: file(
      relativePath: { eq: "whitepapers/commmune-customer-success2.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneOverseasCase: file(
      relativePath: { eq: "whitepapers/commmune-overseascase.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneCommonMistakes: file(
      relativePath: { eq: "whitepapers/commmune-commonmistakes.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneAirbnbAdopted: file(
      relativePath: { eq: "whitepapers/commmune-airbnb_adopted.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneKpiEncyclopedia: file(
      relativePath: { eq: "whitepapers/commmune_kpi_encyclopedia.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneCscommunityReason: file(
      relativePath: { eq: "whitepapers/commmune_cscommunity_reason.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneFanmarketing: file(
      relativePath: { eq: "whitepapers/commmune_fanmarketing.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneCommunitymarketing3merits: file(
      relativePath: { eq: "whitepapers/commmune_communitymarketing_3merits.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneSnsAndCommunitysite: file(
      relativePath: { eq: "whitepapers/commmune_sns_and_communitysite.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    communitymarketingReport_01_2022: file(
      relativePath: { eq: "whitepapers/commmune_communitymarketing_report_01_2022_WP.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    commmuneIntroductionPartnersuccess: file(
      relativePath: { eq: "whitepapers/thumbnail_introduction_partnersuccess.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    CollectionThumbnail: file(
      relativePath: { eq: "whitepapers/case_studies/collection/01/thumbnail.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    BasefoodThumbnail: file(
      relativePath: { eq: "whitepapers/case_studies/basefood/01/thumbnail.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Basefood2Thumbnail: file(
      relativePath: { eq: "whitepapers/case_studies/basefood/02/thumbnail.png" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    BauThumbnail: file(
      relativePath: {
        eq: "whitepapers/case_studies/baucommunications/01/thumbnail.jpg"
      }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    WingArcThumbnail: file(
      relativePath: {
        eq: "whitepapers/case_studies/wingarc1st/01/thumbnail.jpg"
      }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    OBCThumbnail: file(
      relativePath: { eq: "whitepapers/case_studies/obc/01/thumbnail.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    UsacThumbnail: file(
      relativePath: { eq: "whitepapers/case_studies/usac/01/thumbnail.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Mikawaya21Thumbnail: file(
      relativePath: { eq: "whitepapers/case_studies/mikawaya21/01/thumbnail.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    LifeworkdesignThumbnail: file(
      relativePath: { eq: "whitepapers/case_studies/life&workdesign/01/thumbnail.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 475) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
